import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

// Assets
import {black500, greyishBlue500} from "assets/jss/main";

ExternalId.propTypes = {
    externalId: PropTypes.string.isRequired,
};

function ExternalId({externalId}) {
    return (
        <span
            style={{
                fontSize: '20px',
                fontWeight: 'bold',
                color: greyishBlue500
            }}
        >
            <FormattedMessage id='wms.cc.list.takeoutShipment.popup.externalId' />
            <span style={{ color: black500}}>{externalId}</span>
        </span>
    );
}

export default ExternalId;
